import { InjectionToken } from '@angular/core';
import type { UiConfig } from './ui.interface';

export const UI_CONFIG = new InjectionToken<UiConfig>('UiConfig');
